export default {
    aws: {
      AWS_COMMIT_ID: 'a31619144227c5e54eec0914ae4891eeb9d5ffe3',
    },
  };